import 'core-js/features/array/to-sorted.js'
import "config/ajax.ts";
import "config/i18n.ts";
import "config/date.ts";//make sure its loaded after i18n
import "config/browser.ts";



if (process.env.NODE_ENV === "production") {
  import(/* webpackChunkName: "sentry" */ "@sentry/react")
    .then((Sentry) => {
      window.Sentry = Sentry;
      window.Sentry.init({
        dsn: "https://c44f42c7b740d99b770b4c8126c13c82@o260384.ingest.us.sentry.io/4507703686594560",
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration()
        ],
        // Performance Monitoring
        tracesSampleRate: 0.1, //  Capture 10% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/betheremap\.com/, "http://localhost:8091"],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
    });
}

